import React from 'react';
import apiClient, { getAccessToken } from '../../apiClient';
import { withRouter } from 'react-router-dom';
import AddBoxIcon from "@material-ui/icons/AddBox";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import MaterialTable from '../../Components/DataTable/DataTable';
import { CSVLink } from "react-csv";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import { Button, Table, TableBody, TableCell, TableHead, TableRow, Checkbox, FormControlLabel } from "@material-ui/core";
import withFlashNotification from '../Notification/withFlashNotification';
import { notifyApiError } from '../Notification/notificationHelpers';

class ItemLocation extends React.Component {
  state = {
    Results: [],
    showEdit: false,
    currentItemLocationId: 0,
    currentLocationName: '',
    currentIsDefault: false,
    fullWidth: true,
    maxEditWidth: 'md',
    columns: [
      {
        title: '',
        field: 'ItemLocationId',
        render: (rowData) => (
          <a href="javascript:void(0)" onClick={() => this.handleLinkEditClick(rowData, 'edit')}>
            Edit
          </a>
        ),
      },
      { title: "Location Name", field: "LocationName" },
      {
        title: "Default",
        field: "IsDefault",
        render: (rowData) => (rowData.IsDefault === 1 || rowData.IsDefault === true ? 'Yes' : 'No'),
      },
    ],
    headers: [
      { label: "Location Name", key: "LocationName" },
      { label: "Default", key: "IsDefault" },
    ],
    submitted: false,
    successMessage: null,
    errorMessage: null,
    IsAdded: false,
    rows: [],
    showConfirm: false,
    rowIndex: 0,
  };

  componentDidMount() {
    sessionStorage.setItem('TranSearch', null);
    const user = JSON.parse(sessionStorage.getItem('user'));
    let accessToken = getAccessToken();

    apiClient.get(`/api/get/itemlocation`, { headers: {"Authorization" : `Bearer ${accessToken}`} })
      .then((res) => this.setState({ Results: res.data || [] }))
      .catch(error => notifyApiError(
        this.props.showFlashNotification,
        error,
        'Unable to load item locations.'
      ));

    if (user.permissions.filter((x) => x.PermissionName == 'Inventory' && x.PermissionAllowed == 1).length == 0) {
      const { history } = this.props;
      history.push('/home');
    }
  }

  setShowEdit = (state) => this.setState({ showEdit: state });

  handleLinkEditClick = (item) => {
    this.setShowEdit(true);
    this.setState({
      currentItemLocationId: item.ItemLocationId,
      currentLocationName: item.LocationName || '',
      currentIsDefault: item.IsDefault === 1 || item.IsDefault === true,
    });
  };

  handleInputChangeLocationName = (e) => {
    this.setState({ currentLocationName: e.target.value });
  };

  handleEditDefaultToggle = (e) => {
    this.setState({ currentIsDefault: e.target.checked });
  };

  handleEditName = () => {
    const user = JSON.parse(sessionStorage.getItem('user'));
    const accessToken = user.accessToken;
    apiClient.post(
      `/api/post/itemLocationUpdate`,
      {
        locationName: this.state.currentLocationName,
        itemLocationId: this.state.currentItemLocationId,
        isDefault: this.state.currentIsDefault ? 1 : 0,
      },
      { headers: {"Authorization" : `Bearer ${accessToken}`} }
    ).then(() => {
      this.setState({ successMessage: 'Successfully saved!' });
      setTimeout(() => {
        this.setState({ successMessage: null });
        const { history } = this.props;
        history.push('/vendor-details');
        setTimeout(() => {
          history.push('/item-location');
        }, 1);
      }, 3000);
      this.setShowEdit(false);
    }).catch(error => notifyApiError(
      this.props.showFlashNotification,
      error,
      'Unable to update item location.'
    ));
  };

  handleSubmit = () => {
    if (!this.state.rows.length || (this.state.rows[this.state.rows.length - 1].locationname || '').trim() === '') {
      this.setState({ errorMessage: 'Location Name is required in the last added row.' });
      setTimeout(() => this.setState({ errorMessage: null }), 8000);
      return;
    }
    const defaultsInBatch = this.state.rows.filter((r) => r.isDefault === true).length;
    if (defaultsInBatch > 1) {
      this.setState({ errorMessage: 'Only one location can be marked as default.' });
      setTimeout(() => this.setState({ errorMessage: null }), 8000);
      return;
    }
    const user = JSON.parse(sessionStorage.getItem('user'));
    const accessToken = user.accessToken;
    apiClient.post(`/api/post/itemlocations`, this.state.rows, { headers: {"Authorization" : `Bearer ${accessToken}`} })
      .then(() => {
        this.setState({ successMessage: 'Successfully saved!' });
        setTimeout(() => {
          this.setState({ successMessage: null });
          const { history } = this.props;
          history.push('/vendor-details');
          setTimeout(() => {
            history.push('/item-location');
          }, 1);
        }, 3000);
      })
      .catch(error => notifyApiError(
        this.props.showFlashNotification,
        error,
        'Unable to save item locations.'
      ));
  };

  handleNo = () => this.setState({ showConfirm: false });
  handleConfirm = (index) => this.setState({ showConfirm: true, rowIndex: index });
  handleRemoveClick = () => {
    const list = [...this.state.rows];
    this.setState({
      rows: list.filter((x) => x.id !== this.state.rowIndex),
      showConfirm: false,
    });
  };

  handleInputChange = (e, index) => {
    const { name, value, type, checked } = e.target;
    const list = [...this.state.rows];
    list[index][name] = type === 'checkbox' ? checked : value;
    if (name === 'isDefault' && checked) {
      list.forEach((r, idx) => {
        if (idx !== index) r.isDefault = false;
      });
    }
    this.setState({ rows: list });
  };

  handleAdd = () => {
    if (
      this.state.rows.length > 0 &&
      (!this.state.rows[this.state.rows.length - 1].locationname ||
        this.state.rows[this.state.rows.length - 1].locationname.trim() === '')
    ) {
      this.setState({ errorMessage: 'In last item added, Location Name is required.' });
      setTimeout(() => this.setState({ errorMessage: null }), 8000);
      return;
    }
    this.setState({
      IsAdded: true,
      rows: [
        ...this.state.rows,
        { id: this.state.rows.length + 1, locationname: '', isDefault: false },
      ],
    });
  };

  render() {
    return (
      <div className="ItemCategory">
        <h2>Item Locations</h2>
        <div style={{ display: "flex", justifyContent: "space-between", marginTop: "20px" }}>
          <div className="alignDiv">
            <Button onClick={this.handleAdd}>
              <AddBoxIcon onClick={this.handleAdd} />
              ADD
            </Button>
          </div>
        </div>

        <div style={{ marginTop: "10px" }}>
          <Table size="small" aria-label="a dense table">
            <TableHead>
              <TableRow>
                <TableCell align="center">Location Name</TableCell>
                <TableCell align="center">Default</TableCell>
                <TableCell align="center" />
              </TableRow>
            </TableHead>
            <TableBody>
              {this.state.rows.map((row, i) => (
                <TableRow key={`row-${row.id}`}>
                  <TableCell padding="none" style={{ textAlign: 'left' }}>
                    <input
                      type="text"
                      value={row.locationname}
                      name="locationname"
                      onChange={(e) => this.handleInputChange(e, i)}
                    />
                  </TableCell>
                  <TableCell align="center">
                    <input
                      type="checkbox"
                      checked={!!row.isDefault}
                      name="isDefault"
                      onChange={(e) => this.handleInputChange(e, i)}
                    />
                  </TableCell>
                  <TableCell component="th" scope="row" align="center">
                    <Button className="mr10" onClick={() => this.handleConfirm(row.id)}>
                      <DeleteOutlineIcon />
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <br /><br /><br />
          <Button color="primary" variant="contained" onClick={this.handleSubmit} disabled={this.state.submitted}>
            {this.state.submitted ? 'Your form is submitted!' : 'Submit'}
          </Button>

          {this.state.successMessage && (
            <div style={{ backgroundColor: '#28a745', color: '#fff', padding: '10px', marginTop: '10px' }}>
              {this.state.successMessage}
            </div>
          )}
          {this.state.errorMessage && (
            <div style={{ backgroundColor: '#FF7F7F', color: '#fff', padding: '10px', marginTop: '10px' }}>
              {this.state.errorMessage}
            </div>
          )}
        </div>

        <div style={{ maxWidth: '100%', paddingTop: '50px' }}>
          <div style={{ textAlign: 'right', paddingBottom: '3px' }}>
            <CSVLink data={this.state.Results} headers={this.state.headers}>
              Export to Excel
            </CSVLink>
          </div>
          <MaterialTable columns={this.state.columns} data={this.state.Results} title="Item Locations" />
        </div>

        {this.state.showConfirm && (
          <Dialog open={this.state.showConfirm} onClose={this.handleNo}>
            <DialogTitle>{"Confirm Delete"}</DialogTitle>
            <DialogContent>
              <DialogContentText>Are you sure to delete</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => this.handleRemoveClick()} color="primary" autoFocus>Yes</Button>
              <Button onClick={this.handleNo} color="primary" autoFocus>No</Button>
            </DialogActions>
          </Dialog>
        )}

        {this.state.showEdit && (
          <Dialog fullWidth={this.state.fullWidth} maxWidth={this.state.maxEditWidth} open={this.state.showEdit} onClose={() => this.setShowEdit(false)}>
            <DialogTitle>
              <div style={{ float: "left" }}><h4>Edit Item Location</h4></div>
              <div style={{ float: "right" }}>
                <IconButton aria-label="close" onClick={() => this.setShowEdit(false)}>
                  <CloseIcon />
                </IconButton>
              </div>
            </DialogTitle>
            <DialogContent>
              <DialogContentText>
                <div className="row mt-5">
                  <div className="row mt-5">
                    <div className="col-md-5" style={{ float: "left", marginRight: "50px" }}>
                      <label>Location Name</label>
                    </div>
                    <div className="col-md-7">
                      <input
                        style={{ width: "250px" }}
                        type="text"
                        value={this.state.currentLocationName}
                        name="locationName"
                        onChange={(e) => this.handleInputChangeLocationName(e)}
                      />
                    </div>
                  </div>
                  <br />
                  <div className="row mt-5">
                    <div className="col-md-5" style={{ float: "left", marginRight: "50px" }}>
                      <label>Default</label>
                    </div>
                    <div className="col-md-7">
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={!!this.state.currentIsDefault}
                            onChange={this.handleEditDefaultToggle}
                            color="primary"
                          />
                        }
                        label="Set as default location"
                      />
                    </div>
                  </div>
                  <br />
                  <div className="row mt-5" style={{ textAlign: "center" }}>
                    <div className="col-md-6 mr-1" style={{ textAlign: "center", float: "left", marginRight: "2px" }}>
                      <Button className="mr10" color="primary" variant="contained" onClick={this.handleEditName}>
                        Save
                      </Button>
                    </div>
                    <div className="col-md-6" style={{ textAlign: "center", float: "left" }}>
                      <Button className="mr10" color="primary" variant="contained" onClick={() => this.setShowEdit(false)}>
                        Close
                      </Button>
                    </div>
                  </div>
                </div>
              </DialogContentText>
            </DialogContent>
            <DialogActions />
          </Dialog>
        )}
      </div>
    );
  }
}

export default withRouter(withFlashNotification(ItemLocation));
